export default __webpack_public_path__ + "static/media/excellent_active.404ad0b7.svg";